export default "__VITE_ASSET__C0J9JNwk__"